import React, { useState } from "react";
import {
  Grid,
  Typography,
  makeStyles,
  Button,
  TextField,
} from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import InputMask from "react-input-mask";
import { Link } from "react-router-dom";
import styles from "../../../styles/global-styles";
import CategorySelect from "../../shared/selects/CategorySelect";
import StatusGuaranteeSelect from "../../shared/selects/StatusGuaranteeSelect";
import { GuaranteeService } from "../../../services/guarantee.service";
import SiteSelect from "../../shared/selects/SiteSelect";

const useStyles = makeStyles((theme) => ({
  title: styles.title,
  rightButton: styles.rightButton,
  textField: {
    "& .MuiOutlinedInput-root": {
      width: "230px",
      maxWidth: 250,
    },
  },
}));

const HeaderGuaranteeContainer = ({ guaranteeResults, inSite }) => {
  const classes = useStyles();

  const [queryParams, setqueryParams] = useState({});
  /** Picker dates */
  const [startDate, setStartDate] = React.useState(
    moment().subtract(1, "days").startOf("day").format()
  );
  const [endDate, setEndDate] = React.useState(moment().endOf("day").format());

  const handleOptionSelected = (key, value) => {
    console.log("queryParams", Object.values(queryParams).length);
    setqueryParams({ ...queryParams, [key]: value === "none" ? "" : value });
  };

  const handleImeiInput = ({ target: { name, value } }) =>
    setqueryParams({ ...queryParams, [name]: value });

  const handleStartChange = (date) =>
    setStartDate(moment(date).startOf("day").format());

  const handleEndChange = (date) =>
    setEndDate(moment(date).endOf("day").format());

  const searchDistributionByFilters = async () => {
    const utcStartDate = moment(startDate).utc().format();
    const utcEndDate = moment(endDate).utc().format();
    if (moment(endDate).isAfter(moment(startDate))) {
      try {
        /** Validate IMEI not selectable with accesory filter */
        if (queryParams.productTypeId === 2 && queryParams.imeiCode) {
          const noDataFound = {
            noData:
              "Un IMEI no puede estar asociado a un accesorio, corregir filtros ",
          };
          throw noDataFound;
        }
        const body = {
          ...queryParams,
          startDate: utcStartDate,
          endDate: utcEndDate,
        };
        console.log("queryParams", body);
        const { data } = await GuaranteeService.getGuaranteesWithParams(body);
        console.log("guarantees data ", data);
        if (data.length) {
          guaranteeResults(data, true);
        } else {
          const noDataFound = {
            noData: "No se encontraron garantías con los filtros seleccionados",
          };
          throw noDataFound;
        }
      } catch (error) {
        guaranteeResults(error, false);
      }
    } else {
      const error = {
        noData: "La fecha de inicio es MAYOR a la fecha de fin",
      };
      guaranteeResults(error, false);
    }
  };

  return (
    <>
      <Typography variant="h4" component="h4" className={classes.title}>
        Garantías
      </Typography>
      <Grid
        container
        style={{ margin: "20px 0" }}
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <Grid item>
            <DatePicker
              disableToolbar
              variant="inline"
              format="DD/MM/yyyy"
              margin="normal"
              autoOk
              disableFuture
              label="Fecha de inicio"
              placeholder="20/02/2021"
              value={startDate}
              onChange={handleStartChange}
            />
          </Grid>
          <Grid item>
            <DatePicker
              disableToolbar
              variant="inline"
              format="DD/MM/yyyy"
              margin="normal"
              autoOk
              placeholder="21/02/2021"
              disableFuture
              label="Fecha de fin"
              value={endDate}
              onChange={handleEndChange}
            />
          </Grid>
        </MuiPickersUtilsProvider>
        <Grid item>
          <SiteSelect
            title="Sucursal"
            site={handleOptionSelected}
            removeStore
            showNone
          />
        </Grid>
        <Grid item>
          <CategorySelect
            category={handleOptionSelected}
            showNone
            guarantees
            removeChip
          />
        </Grid>
        <Grid item>
          <StatusGuaranteeSelect status={handleOptionSelected} showNone />
        </Grid>
        <Grid item style={{ marginTop: 20 }}>
          <InputMask
            mask="999999999999999"
            maskChar=""
            style={{ maxWidth: 150, widht: 150 }}
            value={queryParams.imeiCode || ""}
            onChange={(e) => handleImeiInput(e)}
          >
            {() => (
              <TextField
                className={classes.textField}
                name="imeiCode"
                placeholder="Código IMEI"
                variant="outlined"
              />
            )}
          </InputMask>
        </Grid>
        <Grid item>
          <Button
            className={classes.rightButton}
            disabled={!Object.values(queryParams).length}
            variant="contained"
            color="primary"
            onClick={searchDistributionByFilters}
            endIcon={<SearchIcon color="secondary" />}
          >
            Buscar
          </Button>
        </Grid>
      </Grid>

      {inSite && (
        <Grid item>
          <Link
            to={{
              pathname: `/dashboard/inventario/nueva-garantia`,
            }}
            className={classes.link}
          >
            <Button
              className={classes.rightButton}
              variant="contained"
              color="primary"
              endIcon={<AddCircleIcon color="secondary"></AddCircleIcon>}
            >
              Nueva garantía
            </Button>
          </Link>
        </Grid>
      )}
    </>
  );
};

export default HeaderGuaranteeContainer;
